module.exports = __webpack_public_path__ + "img/Gera_Urkunde_340729328_.jpg";